// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_3Dfq5xW_vI0JP7s-pwcDGb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.scss
// module id = 1249
// module chunks = 1